import { render } from "./MyPages.vue?vue&type=template&id=0fa8c545"
import script from "./MyPages.vue?vue&type=script&lang=js"
export * from "./MyPages.vue?vue&type=script&lang=js"

import "./MyPages.vue?vue&type=style&index=0&id=0fa8c545&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__